import * as React from 'react';
import { SurveyWidget } from '@cian/commercial-survey-widget';

import { Modal } from '../modal';
import { ModalWrapper } from '../modal/wrapper';

import * as styles from './index.css';
import { TSurveyWidgetModalProps } from './container';

export const SurveyWidgetModal: React.FC<TSurveyWidgetModalProps> = props => (
  <ModalWrapper>
    <Modal minHeigth={200} minWidth={640}>
      <div className={styles['body']}>
        <SurveyWidget {...props} onSOPREvent={props.trackOfferPullActions} />
      </div>
    </Modal>
  </ModalWrapper>
);

SurveyWidgetModal.displayName = 'SurveyWidgetModal';
